import { IonButton, IonIcon, IonRouterLink, IonText } from '@ionic/react';
import React from 'react';

import ButtonContainer from '@/components/common/buttonContainer/ButtonContainer';
import Spacer from '@/components/common/spacer/Spacer';
import RequestSummary from '@/components/summary/requestSummary/RequestSummary';
import { useLanguage } from '@/contexts/LanguageContext';
import { useScheduleFlow } from '@/contexts/ScheduleFlowContext';
import { ROUTES } from '@/utils/routes';
import { arrowForwardCircleOutline } from 'ionicons/icons';

import './Confirmation.css';

const Confirmation: React.FC = () => {
  const { t } = useLanguage();
  const {
    clinic,
    selectedDentist: dentist,
    patient,
    request,
    durationInMinutes,
    confirmRequest: onConfirm,
    reset: onReset
  } = useScheduleFlow();

  const copy = {
    subHeader: t('schedule.confirmation.subHeader'),
    header: (
      <>
        {t('schedule.confirmation.header.confirm')}{' '}
        <IonText color="primary">
          {t('schedule.confirmation.header.appointment')}
        </IonText>{' '}
        {t('schedule.confirmation.header.details')}
      </>
    ),
    message: (
      <>
        {t('schedule.confirmation.message.review')}{' '}
        <i>{t('schedule.confirmation.message.requestAppointment')}</i>{' '}
        {t('schedule.confirmation.message.proceed')}
      </>
    ),
    buttonText: t('schedule.confirmation.buttonText'),
    startOverPrompt: t('schedule.confirmation.startOverPrompt'),
    startOverText: t('schedule.confirmation.startOverText'),
    agreementPrefix: t('schedule.confirmation.agreementPrefix'),
    termsText: t('schedule.confirmation.termsText'),
    andText: t('schedule.confirmation.andText'),
    privacyText: t('schedule.confirmation.privacyText')
  };

  return (
    <div id="confirmation">
      <Spacer top={8} bottom={24}>
        <h4 id="subHeader">{copy.subHeader}</h4>
        <h1 id="header">{copy.header}</h1>
        <p id="message">{copy.message}</p>
      </Spacer>
      <RequestSummary
        clinic={clinic}
        dentist={dentist}
        patient={patient}
        request={request}
        showStatus={false}
        durationInMinutes={durationInMinutes}
      />
      <Spacer top={16} bottom={172}>
        <div id="startOver">
          <p>{copy.startOverPrompt}</p>
          <IonRouterLink onClick={onReset}>{copy.startOverText}</IonRouterLink>
        </div>
      </Spacer>
      <ButtonContainer translucent={false}>
        <IonButton
          id="nextButton"
          onClick={onConfirm}
          expand="block"
          fill="solid"
          size="default"
          color="primary"
          strong={true}
        >
          <IonIcon slot="start" icon={arrowForwardCircleOutline}></IonIcon>
          {copy.buttonText}
        </IonButton>
        <p id="confirmationNote">
          {copy.agreementPrefix}{' '}
          <IonRouterLink routerLink={ROUTES.TERMS_OF_SERVICE} target="_blank">
            {copy.termsText}
          </IonRouterLink>{' '}
          {copy.andText}{' '}
          <IonRouterLink routerLink={ROUTES.PRIVACY_POLICY} target="_blank">
            {copy.privacyText}
          </IonRouterLink>
          .
        </p>
      </ButtonContainer>
    </div>
  );
};

export default Confirmation;
